/**
 * wechat framework
 */
import base64 from '../../base/js-base64';
import intopb from './into.pb';
import purlpb from './purl.pb';
import publicpb from '../../base/public.pb';
import PbAjax from '../../lib/pbajax';
import events from '../../base/events';
import lang from '../../lang/index';
import notification from 'c-notification';
import loading from 'c-up-loading';

let WebChat = function() {
    this.initialize.apply(this, arguments);
}

WebChat.prototype = Object.assign({

    /**
     * initialize
     * @param cfg {object} 
     *  - userToken {string} current userToken
     *  - roomId {int} room id
     *  - wType {string} define the client type which create websocket object, options: 0 pcweb 1 mobileweb
     *  - insg {boolean} the field will decide which server to send the request to, true -> Singapore, false->China
     * @return void
     */
    initialize: function(cfg) {
        this.pingTimeout = 10; // second
        this.userToken = cfg.userToken;
        this.wType = cfg.wType;
        this.roomId = cfg.roomId;
        this.onlyView = cfg.onlyView;
        this.agreePayFlag = cfg.agreePayFlag;
        this.pbajax = new PbAjax();
        this.needAckMsg = {};
        this.getIntoMsg();
    },

    /**
     * get websocket params and all the valid message from server, such as video source, etc.
     * @return void
     */
    getIntoMsg: function(agreePay) {
        let self = this;
        let agreePayFlag = false;

        if (typeof this.agreePayFlag !== 'undefined') {
            agreePayFlag = this.agreePayFlag;
        }
      
        let data = {
            roomId: this.roomId,
            wType: this.wType,
            checkLifted: true,
            agreePayFlag
        };

        this.pbajax.do(
            {
                service: 'room',    
                api: '/room/web/normal/into',  
                header: {
                    userToken: this.userToken,
                    'Accept-Language': lang.type
                }
            }, 
            new intopb.Room.WebNormalInto.Request(data), 
            (res)=>{
                loading.hide();
                var dataWrap = publicpb.Result.decode(res);
                var data;

                if (dataWrap.code == 1) {
                    data = intopb.Room.WebNormalInto.Response.decode(dataWrap.data.value);
                    data.isLimitSpeak = !data.checkLiftedR;
                    this.data = data;
                    self.sid = longToString(data.sid);
                    self.userInfo = data.userInfo;

                    if (!self.onlyView) {
                        this.initSocket(data);
                    }
                    
                    // 直播类型，0：免费公播；1:收费公播；2: 免费私播；3：收费私播
                    let liveType = 0;

                    if (data.privateLiveFlag) {
                        //  私播
                        if (parseInt(longToString(data.fee), 10) > 0) {
                            liveType = 3;
                        } else {
                            liveType = 2;
                        }
                    } else {
                        if (parseInt(longToString(data.fee), 10) > 0) {
                            liveType = 1;
                        } else {
                            liveType = 0;
                        }
                    }
                    data.liveType = liveType;
                    this.liveType = liveType;
                    if (data.privateLiveFlag) {
                        self.emit('getIntoException', 'sibo');
                    } else {
                        this.emit('getIntoSuccess', data);    
                    }
                } else {
                    if (dataWrap.code == 20508) {
                        data = intopb.Room.WebNormalInto.Response.decode(dataWrap.data.value);
                        this.agreePayFee = longToString(data.fee);

                        if (data.privateLiveFlag) {
                            self.emit('getIntoException', 'sibo');
                            return;
                        }
                    } else if (dataWrap.code == 12291) {
                        this.agreePayFlag = false;
                    }
                    // 20482 live room disabled
                    // 4096 parameter error
                    // 8192 need relogin
                    // 20508 this room need charge
                    // 20512 私播直播间人数达到上限
                    // 12291 私播购买U钻不够
                    // 12296 私播购买失败
                    self.emit('getIntoException', dataWrap.code);
                }
            }, 
            ()=>{
                self.emit('getIntoTimeout');
            }, 
            ()=>{
                self.emit('getIntoFail');
            }
        );
    },

    /**获取横屏标识*/
    getGameLivingFlag: function(agreePay) {
        let promise = $.Deferred();
        let isGameFlag = false;
        let self = this;
        let agreePayFlag = false;

        if (typeof this.agreePayFlag !== 'undefined') {
            agreePayFlag = this.agreePayFlag;
        }
      
        let data = {
            roomId: this.roomId,
            wType: this.wType,
            checkLifted: true,
            agreePayFlag
        };

        this.pbajax.do(
            {
                service: 'room',    
                api: '/room/web/normal/into',  
                header: {
                    userToken: this.userToken,
                    'Accept-Language': lang.type
                }
            }, 
            new intopb.Room.WebNormalInto.Request(data), 
            (res)=>{
                loading.hide();
                var dataWrap = publicpb.Result.decode(res);
                var data;
                
                if (dataWrap.code == 1) {
                    data = intopb.Room.WebNormalInto.Response.decode(dataWrap.data.value);
                    data.isLimitSpeak = !data.checkLiftedR;
                    this.data = data;
                    // 游戏直播，通过liveModel == 2 来判断。标签和横竖屏都不准确。
                    isGameFlag = data.liveModel == 2;
                } 
                promise.resolve(isGameFlag);
            }, 
            ()=>{
                promise.resolve(isGameFlag);
            }, 
            ()=>{
                promise.resolve(isGameFlag);
            }
        );
        
        return promise;
    },

    getPUrl: function(success){
        let { Request, Response } = purlpb.Room.WebNormalPurlGet;

        let businessData = new Request({
            roomId: this.roomId
        });

        this.pbajax.do(
            {
                service: 'room',     
                api: '/room/web/normal/purl/get',  
                header: {
                    userToken: this.userToken
                }
            }, 
            businessData, 
            (res)=>{
                loading.hide();
                
                var dataWrap = publicpb.Result.decode(res);
                var data;

                if (dataWrap.code == 1) {
                    data = Response.decode(dataWrap.data.value);    

                    let liveMsg = base64.decode(base64.decode(data.purl));
                    
                    success({
                        liveMsg: liveMsg
                    });
                } else  {
                    // 检查到用户不在房间返回错误码SC_LIVE_ROOM_NO_PERMISSION
                    // code: 20483 , msg: "user have no permission!"
                }
            }, 
            ()=>{
                
            }, 
            ()=>{
               
            }
        );
    },

    // 初始化websocket连接
    initSocket: function(data) {
        const isHttps = location.protocol === 'https:';
        const whiteList = [ 
            'wsappawebsg.upliveapp.com',
            'nowsappawebsg.upliveapp.com',
            'wsappawebsgstage.upliveapp.com',
            'nowsappawebsgstage.upliveapp.com'
        ];
        let protocol = 'ws://';

        if (whiteList.indexOf(data.wsIp) > -1) {
            protocol = 'wss://';
            data.wsPort = 443;
        } else {
            if (isHttps) {
                data.wsPort = 443;
                data.wsIp = 'sg-chat.upliveapp.com';
                protocol = 'wss://';
            }
        }

        var socketUrl = protocol + data.wsIp + ':' + data.wsPort + data.wsPath + '?';

        var search = {
            sid: this.sid,
            roomId: this.roomId,
            time: longToString(data.time),
            nonce: data.nonce,
            termType: data.termType,
            userInfo: this.userInfo,
            sec: data.sec
        };
        socketUrl += this.pbajax.serializeURI(search);
        this.createSocket(socketUrl);
    },

    /**
     * create websocket
     */
    createSocket: function(url) {
        if (!('WebSocket' in window)) {
            return;
        }
        console.info('--create--');
        this.url = url;
        this.socket = new WebSocket(url);
        this.bindEventToSocket();
    },

    // 监听socket事件
    bindEventToSocket: function() {
        var self = this;
        var timer;
        this.socket.onopen = function(res) {
            self.emit('open');
            
            this.closeByManual = false;
            // if user has logined
            if (self.userInfo) {
                timer = setTimeout(function() {
                    clearTimeout(timer);
                    self.sendAttend();
                }, 300);
            }

            self.createPingTimer();
            
        }
        this.socket.onmessage = function(resp) {
            var data;

            // 如果是pong报文, 则不会出发message事件
            if (resp.data == 4) {
                // console.log('pong')
                return;
            }
            
            // 若数据结构未加密
            if (resp.data.indexOf('{') > -1) {
                data = JSON.parse(resp.data);
            } else {
                data = self.parseDownlinkMessage(resp.data);
            }
            
            // console.log(data)
            if (data.type == 1) {
                // 未出席成功
                if (data.extenseBody.rResult != 0) {
                    self.emit('attendFail', data.extenseBody.rResult);
                }
                return;
            }
            /**
             * 回执消息处理
             **/
            if (data.needAck){
                let uniqueId = data.msgId+'-'+data.roomId;
                if (self.needAckMsg[uniqueId]) {
                    return ;
                } else {
                    self.needAckMsg[uniqueId] = uniqueId;                   
                    self.sendAckMsg(data);
                }
            }
            self.emit('message', data);
        }
        this.socket.onclose = function(status) {
            // 1000
            self.emit('close', status);
            self.destroyPingTimer();
        }
    },
    sendAckMsg: function(msg){
        let result = {
            msgId: msg.msgId,
            sId: msg.sId,
            roomId: parseInt(msg.roomId),
            type: msg.type,
            mType: msg.mType
        };
        this.send(result);

    },
    // 重连
    reconnect: function() {
        console.info('--reconnect--');
        // console.log('socket reconnect');
        this.socket = new WebSocket(this.url);
        this.bindEventToSocket();
    },

    reinit: function() {
        this.getIntoMsg();
    },

    // 发送报文到服务器
    send: function(msg) {        
        // ping request
        if (msg == 3) {
            this.socket.send(msg);
            return;
        }
        if (!this.socket) {
            console.log('pls create the WebSocket first!');
            return;
        }
    
        if (!msg || typeof msg != 'object') {
            console.log('Parameter format error, pls check document again!');
            return;
        }

        var result = this.parseUplinkMessage(msg);
        
        try{
            this.socket.send(result);
        } catch(e) {
            console.error(e.message);
        }

        switch ($.debugForDeveloperMode) {
            case 1:
                this.close();
                $.debugForDeveloperMode = 0;
                break;
            case 2:
                this.reinit();
                $.debugForDeveloperMode = 0;
                break;
            case 3:
                this.reconnect();
                break;
        }
    },

    // 建立连接后, 登录用户需发送出席报文, 否则无法发送消息
    sendAttend: function() { 

        this.send({
            type: 1, 
            mType: 0, 
            roomId: this.roomId, 
            sId: this.sid,
            liveType: this.liveType,
            sendTime: +new Date,
            appVersion: '3.0.0',
            appBuildId: '',
            countryCode: UP.Global.getUserCountryCode(),
            extenseBody: {
                userInfo: this.userInfo,
                userToken: this.userToken,
                termType: 3, // PC手机网页"WEB"
                isShowHighText: UP.Global.getHighLevelText() == 1 ? true : false
            }
        });
    },

    // 上行报文格式化
    parseUplinkMessage: function(msg) {
        var extenseBody = msg.extenseBody;
        extenseBody = base64.encode(base64.encode(JSON.stringify(extenseBody)));
        msg.extenseBody = extenseBody;

        return base64.encode(JSON.stringify(msg));
    },

    // 下行报文格式化
    parseDownlinkMessage: function(msg) {
        if (msg == 4) {
            return msg;
        }
        return JSON.parse(base64.decode(msg));
    },

    // 创建ping定时器
    createPingTimer: function() {
        var self = this;
        this._pingTimer && clearInterval(this._pingTimer);
        self._pingTimer = setInterval(function() {
            // console.log('ping');
            self.socket.send(3);
        }, this.pingTimeout * 1000);
    },

    // 手动断开
    close() {
        this.closeByManual = true;
        
        if (this.socket) {
            this.socket.close();
            console.info('---close--');
        }
    },

    // 销毁ping定制器
    destroyPingTimer: function() {
        this._pingTimer && clearInterval(this._pingTimer);
    }

}, events);

export default WebChat;





// WEBPACK FOOTER //
// ./js/component/webchat/index.js